import { render, staticRenderFns } from "./CredentialInfo.vue?vue&type=template&id=4f115ef5&"
import script from "./CredentialInfo.vue?vue&type=script&lang=ts&"
export * from "./CredentialInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CredentialInfo.vue?vue&type=style&index=0&id=4f115ef5&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports